export default __webpack_public_path__ + "static/media/imgNature1.f1c3fd0d.png";